module.exports = __webpack_public_path__ + "static/img/5.4a0616d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/5.png
// module id = cECq
// module chunks = 0